import FadeDiv from "./common/FadeDiv";
import React from "react";
import clsx from "clsx";

interface GailHelpsCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  disableFade?: boolean;
}

const GailHelpsCard: React.FC<GailHelpsCardProps> = ({
  title,
  description,
  icon,
  disableFade = false,
}) => {
  const content = (
    <div className={clsx("flex", "flex-col", "h-full justify-between")}>
      <div className={clsx("mb-6")}>{icon}</div>
      <div>
        <h2 className={clsx("text-xl", "font-medium", "mb-2", "leading-6")}>
          {title}
        </h2>
        <p className={clsx("text-base", "text-gray-600", "leading-5", "z-10")}>
          {description}
        </p>
      </div>
    </div>
  );

  return (
    <div
      className={clsx(
        "md:px-4",
        "lg:px-6",
        "md:mt-4",
        "md:pt-8",
        "md:pb-0",
        "bg-white"
      )}
    >
      <div
        className={clsx(
          "absolute",
          "w-full",
          "left-0",
          "bg-white",
          "h-12",
          "mt-[calc(-3rem-1px)]",
          "hidden",
          "md:block",
          "z-0"
        )}
      ></div>
      {disableFade ? (
        <div className={clsx("flex", "flex-col")}>{content}</div>
      ) : (
        <FadeDiv className={clsx("flex", "flex-col", "h-full")}>
          {content}
        </FadeDiv>
      )}
    </div>
  );
};

export default GailHelpsCard;
